import { AdminInfoData } from "app/types-shared";

export const filterReplacementsAccess = (adminPanelAccess?: AdminInfoData) => {
  return !!(
    adminPanelAccess?.dashboard?.administrationCentral ||
    adminPanelAccess?.companyReport?.administrationCentral ||
    adminPanelAccess?.favourite?.administrationCentral
  );
};
